<template>
    <sa-page-layout :btnBackVisible="false" :btnNewVisible="true" :btnRefreshVisible="true" :linkedit="linkedit" :showModalLoading="showModalLoading" @refresh="onRefresh">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col xs="12" sm="12" md="2" lg="2" xl="2">
                        <label class="sa-label-data">Tipo</label>
                        <b-form-select v-model="filtroArticoliMagazzino.codiceTipoArticolo" type="search" :options="tipoArticoloOptions" text-field="descrizioneTipoArticolo" value-field="codiceTipoArticolo">
                            <template #first>
                                <b-form-select-option :value="null"> - Seleziona Tipo - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                        <label class="sa-label-data">Nome</label>
                        <b-form-input v-model="filtroArticoliMagazzino.nomeArticolo" type="search" placeholder="Inserire nome articolo"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="2" lg="2" xl="2">
                        <label class="sa-label-data">Stato</label>
                        <b-form-select v-model="filtroArticoliMagazzino.stato" :options="statiOptions" value-field="value" text-field="text">
                            <template #first>
                                <b-form-select-option :value="null"> - Seleziona Stato - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row style="margin-top: 5px">
                    <b-col class="sa-padding-right text-right mb-3">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("global.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <magazzino-articoli-list-component ref="cmpMagazzinoArticoliListComponent" @deleteAssociazione="loadDataArticoli" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" @updateFilter="onUpdateFilter" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoArticoliListComponent from "../components/MagazzinoArticoliListComponent.vue";
export default {
    name: "MagazzinoArticoliListPage",
    mixins: [],
    components: { SaPageLayout, MagazzinoArticoliListComponent },
    data() {
        return {
            showModalLoading: false,
            linkedit: "articoli",
            filtroArticoliMagazzino: { nomeArticolo: null, stato: null, codiceTipoArticolo: null },
            statiOptions: [
                { text: "ATTIVO", value: "ATTIVO" },
                { text: "CANCELLATO", value: "CANCELLATO" },
            ],
            tipoArticoloOptions: [{ codiceTipoArticolo: null, descrizioneTipoArticolo: null }],
            pathResourceTipiArticolo: "/magazzinoarticolitipo",
        };
    },
    /* */
    mounted() {
        // let me = this;
        // me.$refs.cmpGestioneAttivitaProgettiListComponent.init(me.filtroArticoliMagazzino);
        // me.loadStati();
        let me = this;
        me.loadDataArticoli();
        me.loadDataTipoArticolo();
    },

    methods: {
        loadDataArticoli() {
            let me = this;
            me.$refs.cmpMagazzinoArticoliListComponent.loadDataArticoli();
        },
        loadDataTipoArticolo() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceTipiArticolo, {}, me.loadDataTipoArticoloSuccess, me.loadDataTipoArticoloError);
        },
        loadDataTipoArticoloSuccess(response) {
            let me = this;
            me.tipoArticoloOptions = response.data.data.list;
            // me.tipoArticoloOptions.unshift({ codiceTipoArticolo: null, descrizioneTipoArticolo: "- Seleziona Articolo -" });
        },
        loadDataTipoArticoloError(error) {
            console.log(error);
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onRefresh() {
            let me = this;
            me.loadDataArticoli();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroMagazzino"] = JSON.stringify(me.filtroArticoliMagazzino);
            me.loadDataArticoli();
        },
        onReset() {
            let me = this;
            me.filtroArticoliMagazzino = { nomeArticolo: null, codiceTipoArticolo: null, stato: null };
            // console.log("filtro in page: ", this.filtroArticoliMagazzino);

            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroMagazzino"] = JSON.stringify(me.filtroArticoliMagazzino);
            me.loadDataArticoli();
        },
        onUpdateFilter(filterData) {
            let me = this;
            // console.log("filtro", filterData);

            me.filtroArticoliMagazzino = filterData;
        },
    },
};
</script>

<style></style>
